export enum ContactType {
  KUNDE = 'KUNDE',
  KUNDE_AP = 'KUNDE_AP',
  LIEFERANT = 'LIEFERANT',
  LIEFERANT_AP = 'LIEFERANT_AP',
  MITARBEITER = 'MITARBEITER',
  BENUTZER = 'BENUTZER',
  BLANK_ADDRESS = 'BLANK_ADDRESS',
}
